<style lang="scss">
@import '$vars';

.preview {
  box-sizing: border-box;

  &.modal-container {
    max-width: 700px !important;
  }

  &__header.modal-header {
    align-items: flex-start;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0;
    padding: 20px 10px 0 10px;
  }

  &__description {
    align-items: flex-start;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
  }

  &__title {
    box-sizing: border-box;
    display: block;
    margin: 0 0 5px 0;
  }

  &__separator {
    margin: 10px;
  }

  &__wrapper.modal-body {
    box-sizing: border-box;
    margin: 10px 10px 10px;
    padding: 0;
  }

  &__question {
    align-items: flex-start;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 10px;
  }
}

.question {
  &__title {
    box-sizing: border-box;
    color: #616161;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: unset;
  }

  &__field {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 100%;

    &--text,
    &--textarea,
    &--select,
    &--number,
    &--date {
      .form-input,
      .form-select,
      .form-date .form-input,
      .form-date .form-input:read-only {
        background-color: #fff;
        border: 1px solid #DEE1E2;
        box-sizing: border-box;
        margin: 5px 1px;
        width: 100%;
      }

      position: relative;
    }

    &--select,
    &--checkbox,
    &--radio {
      label {
        font-size: 0.7rem;
      }
    }

    &--checkbox {
      .form-checkbox {
        width: calc(100% / 3);
      }
    }

    &--radio {
      .form-radio:not(:first-of-type) {
        margin-left: 20px;
      }
    }
  }
}

div {
  &.loader.flex-center {
    padding: 40px;
  }
}
</style>

<template>
  <section class="preview modal modal-md2 active">
    <a class="modal-overlay" aria-label="Close" @click="$emit('close')"></a>

    <article class="modal-container preview">
      <header class="modal-header preview__header" v-if="loaded">
        <div class="preview__description">
          <h5 class="preview__title">{{ anamnesis.name }}</h5>
        </div>

        <a class="btn btn-clear" aria-label="Close" @click="$emit('close')"></a>
      </header>

      <hr class="preview__separator" v-if="loaded">

      <div class="modal-body preview__wrapper" v-if="loaded">
        <div
          class="preview__question question"
          v-for="(question, i) in anamnesis['custom_anamnesis_questions']"
          :key="`anamnesisPreview_question_${i}`">
          <label class="question__title">
            {{ question.name }}
          </label>

          <template v-if="question['field_type'] === 'TEXT'">
            <div class="question__field question__field--text">
              <input type="text" class="form-input">
            </div>
          </template>

          <template v-if="question['field_type'] === 'TEXTAREA'">
            <div class="question__field question__field--textarea">
              <textarea class="form-input"></textarea>
            </div>
          </template>

          <template v-if="question['field_type'] === 'NUMBER'">
            <div class="question__field question__field--number">
              <input type="number" class="form-input">
            </div>
          </template>

          <template v-if="question['field_type'] === 'DATE'">
            <div class="question__field question__field--date">
              <dr-datepicker
                class="form-date"
                input-class="form-input"
                placeholder="Escolha a data" />
            </div>
          </template>

          <template v-if="question['field_type'] === 'SELECT'">
            <div class="question__field question__field--select">
              <select class="form-select">
                <option
                  v-for="(option, j) in question['custom_anamnesis_question_options']"
                  :key="`anamnesisPreview_question_${i}_option_${j}`">
                  {{ option.name }}
                </option>
              </select>
            </div>
          </template>

          <template v-if="question['field_type'] === 'CHECKBOX'">
            <div class="question__field question__field--checkbox">
              <label
                class="form-checkbox"
                v-for="(option, j) in question['custom_anamnesis_question_options']"
                :key="`anamnesisPreview_question_${i}_option_${j}`">
                <input type="checkbox">
                <i class="form-icon" />
                {{ option.name }}
              </label>
            </div>
          </template>

          <template v-if="question['field_type'] === 'RADIO'">
            <div class="question__field question__field--radio">
              <label
                class="form-radio"
                v-for="(option, j) in question['custom_anamnesis_question_options']"
                :key="`anamnesisPreview_question_${i}_option_${j}`" >
                <input type="radio" :name="`anamnesisPreview_question_${i}_option_radio`">
                <i class="form-icon" />
                {{ option.name }}
              </label>
            </div>
          </template>
        </div>
      </div>

      <div class="loader flex-center" v-if="!loaded">
        <dr-loader
          v-if="!loaded"
          :key="'dr-loader'"
          size="lg"
          class="loader flex-center" />
      </div>
    </article>
  </section>
</template>

<script>
export default {
  props: {
    anamnesisId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      anamnesis: {},
      loaded: false
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.fn_SHOW_PROGRESS()
      this.getAnamnesis(this.anamnesisId)
        .then((res) => {
          this.anamnesis = res
          this.anamnesis['custom_anamnesis_questions'].sort((a, b) => a.position > b.position)

          this.loaded = true
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.fn_HIDE_PROGRESS()
        })
    },

    async getAnamnesis (id) {
      const response = await this.$http.get(`/doctor/custom_anamnesis/${id}`, this.$store.getters.getAuthHeader)
      return response.data
    }
  }
}
</script>
